// import VueScript2 from 'vue-script2'
import scriptX from 'vue-scriptx'
import app from '../main'
const CONEKTA_URL = 'https://cdn.conekta.io/js/latest/conekta.js'

const CONEKTA_PUBLIC = process.env.VUE_APP_CONEKTA_PUBLIC
// "async" is optional
export default async () => {
  return scriptX.load(CONEKTA_URL).then(() => {
    let Conekta = window.Conekta
    app.config.globalProperties.$conekta = Conekta
    Conekta.setPublicKey(CONEKTA_PUBLIC)
    app.provide(Conekta)
    return Conekta
  })
}
